/**
 * This function coerces a string into a string literal type.
 * Using tagged union types in TypeScript 2.0, this enables
 * powerful typechecking of our reducers.
 *
 * Since every action label passes through this function it
 * is a good place to ensure all of our action labels
 * are unique.
 */

import { Vehicle } from "src/lib/angular/model/vehicle/vehicle";
import { NOT_APPLICABLE } from '../../constants/app.constants';

const typeCache: { [label: string]: boolean } = {};
export function type<T>(label: T | ""): T {
  if (typeCache[<string>label]) {
    throw new Error(`Action type "${label}" is not unique"`);
  }

  typeCache[<string>label] = true;

  return <T>label;
}

export const getFullModelText = (vehicleDetails) => {
  if (!vehicleDetails) {
    return '';
  }

  const { year, model, bodyStyleDesc } = vehicleDetails;
  const modelDetails = model || {};

  const hasValidModelValues = Object.values(modelDetails).some(value => value !== NOT_APPLICABLE);

  if (!hasValidModelValues) {
    return 'Model: N/A';
  }

  const modelText = [
    year,
    modelDetails.marketingTitle || bodyStyleDesc,
    modelDetails.modelCd + modelDetails.phaseCd
  ].filter(Boolean).join(' ');

  return modelText;
};
